import { useState, useMemo } from "react";
import './styles.css'
import Map from "./Components/Map"
import { IoSearchSharp } from "react-icons/io5";
import Input from '../../Form/CustomInputs/Input'
import ReactSelect from 'react-select';
import { TbMapExclamation } from "react-icons/tb";

const travelingTypes = [
  { value: 'DRIVING', label: 'Carro' },
  { value: 'WALKING', label: 'A pé' },
]

function RouteMap({ pointA, pointB, onChange, name }) {

  const [travelType, setTravelType] = useState({ value: 'DRIVING', label: 'Carro' })

  const [travelData, setTravelData] = useState(
    {
      distance: 0,
      distance_mesure_unit: "km",
      duration: 0,
      duration_mesure_unit: "minutes",
      travelMode: travelType.value
    }
  )


  const points = useMemo(() => [pointA, pointB], [])


  const handleChange = newValue => {
    const distanceKilometers = parseFloat((newValue.distance / 1000).toFixed(2))
    const durationMinutes = Math.ceil(newValue.duration / 60);

    const finalValues = {
      ...newValue,
      distance: distanceKilometers,
      duration: durationMinutes,
    }

    setTravelData(finalValues);
    onChange(finalValues);
  };


  if (!pointA || !pointB) {
    return (
      <div className="route__map__container" style={{ flexDirection: 'row', gap: 10, padding: 10 }}>
        <TbMapExclamation size={24} style={{ opacity: 0.8 }} />
        <span>Necessário informar o ponto de partida e ponto de chegada</span>
      </div>
    )
  }

  return (
    <>
      <div className="route__map__container">
        <div className="route__map__wrapper">
          <div className="route__map__header">
            <IoSearchSharp size={22} />
            <h4>Mapa do Aluno</h4>
          </div>
          <div className="route__map__form">
            <div className="route__map__form__input">
              <label htmlFor="">Tipo de Rota</label>
              <ReactSelect
                isClearable={false}
                name={"travel_type"}
                options={travelingTypes}
                onChange={(item) => setTravelType(item)}
                value={travelType}
                defaultValue={travelType}
              />
            </div>
            <div className="route__map__form__input">
              <label htmlFor="">Distância</label>
              <Input
                type='text'
                name={'distancia'}
                value={travelData.distance.toFixed(1).replace('.', ',') + 'km'}
                readOnly={true}
              />
            </div>
            <div className="route__map__form__input">
              <label htmlFor="">Tempo Estimado</label>
              <Input
                type='text'
                name={'tempo_estimado'}
                value={travelData.duration + ' minutos'}
                readOnly={true}
              />
            </div>
            <div className="route__map__form__input">
              <label htmlFor="">{pointA.label}</label>
              <Input
                type='text'
                name={'pointA'}
                value={pointA.address}
                readOnly={true}
              />
            </div>
            <div className="route__map__form__input">
              <label htmlFor="">{pointB.label}</label>
              <Input
                type='text'
                name={'pointB'}
                value={pointB.address}
                readOnly={true}
              />
            </div>
          </div>
        </div>
      </div >
      <div className="route__map">
        <Map points={points} travelType={travelType.value} onChange={handleChange} />
      </div>
    </>

  );
}
export default RouteMap;